import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { EventEmitter } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";

@Component({
  selector: "app-update-real-estate-form-dialog",
  templateUrl: "./update-real-estate-form-dialog.component.html",
  styleUrls: ["./update-real-estate-form-dialog.component.scss"],
})
export class UpdateRealEstateFormDialogComponent implements OnInit {
  onConfirm = new EventEmitter();

  projectId: string = "";
  projectData: any = {};

  changeAreaControl = new FormControl("", Validators.required);
  updateRevisionControl = new FormControl("");
  inServiceDateControl = new FormControl("", Validators.required);

  changeAreaOptions = [
    { value: "estimate", label: "Estimate" },
    { value: "change_in_scope", label: "Change in Scope" },
    { value: "both", label: "Both" },
    { value: "completion_in_service", label: "Completion/In-Service" },
    { value: "cancelled", label: "Cancelled" },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UpdateRealEstateFormDialogComponent>
  ) {}

  ngOnInit() {
    this.projectId = this.data.projectId || "";
    this.projectData = this.data.project || {};

    // Set default values from projectData
    if (this.projectData.project && this.projectData.project.version) {
      this.updateRevisionControl.setValue(this.projectData.project.version);
    }
    if (
      this.projectData.project &&
      this.projectData.project.detailForm &&
      this.projectData.project.detailForm.serviceDate
    ) {
      this.inServiceDateControl.setValue(
        this.projectData.project.detailForm.serviceDate
      );
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  get showInServiceDate(): boolean {
    return ['cancelled', 'completion_in_service'].indexOf(this.changeAreaControl.value) !== -1;
  }

  confirmUpdate() {
    if (this.changeAreaControl.invalid || (this.showInServiceDate && this.inServiceDateControl.invalid)) {
      this.changeAreaControl.markAsTouched();
      if (this.showInServiceDate) {
        this.inServiceDateControl.markAsTouched();
      }
      return;
    }

    const status = this.changeAreaControl.value.toString();

    const result: any = {
      status,
      updateRevision: this.updateRevisionControl.value,
      inServiceDate: this.inServiceDateControl.value,
      projectData: this.projectData,
    };

    this.onConfirm.emit(result);
    this.dialogRef.close();
  }
}
